import React, { Component } from "react";
import { connect } from "react-redux";
import domtoimage from "dom-to-image";

import {
  openProcessModal,
  openInfoModal,
  openContributorModal,
  openCommentModal
} from "../actions/modalActions";
import { clearSelectedElement } from "../actions/selectActions";
import { getContributors, setFilterYear } from "../actions/processActions";

import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/icons/Menu";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import AddIcon from "@material-ui/icons/Add";
import InfoIcon from "@material-ui/icons/Info";
import SaveIcon from "@material-ui/icons/Save";
import ListIcon from "@material-ui/icons/List";
import CommentIcon from "@material-ui/icons/Comment";
import PlayIcon from "@material-ui/icons/PlayArrow";

class FloatingActionButton extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, locked: false };
  }

  createAnimation = async () => {
    const currentYear = new Date().getFullYear();
    for (let year = 1975; year <= currentYear; year++) {
      this.props.setFilterYear(year);
      const node = document.getElementsByClassName("table")[0];
      const dataUrl = await domtoimage.toPng(node);
      const a = document.createElement("a");
      a.download = "table" + year;
      a.href = dataUrl;
      a.click();
      a.remove();
    }
  };

  getImage = () => {
    const node = document.getElementsByClassName("table")[0];

    domtoimage
      .toPng(node)
      .then(dataUrl => {
        const a = document.createElement("a");
        a.download = "table";
        a.href = dataUrl;
        a.click();
        a.remove();
      })
      .catch(err => {
        console.error("Error: ", err);
      });
  };

  handleClick = () => {
    this.setState(state => ({
      locked: !state.locked
    }));
  };

  handleHover = () => {
    this.setState({ open: true });
  };

  handleLeave = () => {
    this.setState({ open: false });
  };

  handleClose = () => {
    this.setState({ locked: false });
  };

  handleOpen = () => {
    this.setState({ locked: true });
  };

  render() {
    const actions = [
      {
        icon: <AddIcon />,
        name: "Add process",
        action: () => {
          this.props.openProcessModal();
        }
      },
      {
        icon: <SaveIcon />,
        name: "Save table",
        action: () => {
          this.props.clearSelectedElement();
          this.getImage();
        }
      },
      {
        icon: <CommentIcon />,
        name: "Submit comment",
        action: () => {
          this.props.openCommentModal();
        }
      },
      {
        icon: <ListIcon />,
        name: "Credits",
        action: () => {
          this.props.getContributors();
          this.props.openContributorModal();
        }
      },
      {
        icon: <InfoIcon />,
        name: "Info",
        action: () => {
          this.props.openInfoModal();
        }
      }
    ];

    if (this.props.adminPassword) {
      actions.push({
        icon: <PlayIcon />,
        name: "Animate",
        action: () => {
          this.createAnimation();
        }
      });
    }

    return (
      <SpeedDial
        ariaLabel="SpeedDial"
        style={{ position: "fixed", bottom: "1em", right: "1em" }}
        icon={<SpeedDialIcon />}
        onBlur={this.handleClose}
        onClick={this.handleClick}
        onClose={this.handleClose}
        onMouseEnter={this.handleHover}
        onMouseLeave={this.handleLeave}
        open={this.state.open || this.state.locked}
        direction={"up"}
      >
        {actions.map(action => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => {
              action.action();
              this.setState({ locked: false });
            }}
          />
        ))}
      </SpeedDial>
    );
  }
}

function mapStateToProps(state) {
  return {
    adminPassword: state.admin.password
  };
}

export default connect(
  mapStateToProps,
  {
    openProcessModal,
    openContributorModal,
    openInfoModal,
    openCommentModal,
    getContributors,
    clearSelectedElement,
    setFilterYear
  }
)(FloatingActionButton);
